import {
  IEnumeratedSetValueDatatype,
  IEnumeratedSetContract,
  IEnumerationDefinitionComplexDatatype,
  IEnumerationDefinitionTypeComplex
} from 'utility-js-enumeration';

export * from './enums/day_of_the_week_enum';
export * from './enums/time_window_enum';

export * from './lib/time_utility';

export interface IDayOfTheWeekValue extends IEnumerationDefinitionTypeComplex, IEnumeratedSetValueDatatype {
  microname: string;
  shortname: string;
  longname: string;
  readonly ordinal: number;
  readonly key: string;
  readonly id: string;
  readonly value: any;
}

export interface IDayOfTheWeekEnum extends IEnumeratedSetContract, IEnumerationDefinitionComplexDatatype {
  SU: IDayOfTheWeekValue;
  MO: IDayOfTheWeekValue;
  TU: IDayOfTheWeekValue;
  WE: IDayOfTheWeekValue;
  TH: IDayOfTheWeekValue;
  FR: IDayOfTheWeekValue;
  SA: IDayOfTheWeekValue;
  ONLINE: IDayOfTheWeekValue;
}

export interface ITimeWindowValue extends IEnumerationDefinitionTypeComplex, IEnumeratedSetValueDatatype {
  heading: () => string;
  moment: string;
  readonly ordinal: number;
  readonly key: string;
  readonly id: string;
  readonly value: any;
}

export interface ITimeWindowEnum extends IEnumeratedSetContract, IEnumerationDefinitionComplexDatatype {
  DAY: ITimeWindowValue;
  WEEK: ITimeWindowValue;
  MONTH: ITimeWindowValue;
  QUARTER: ITimeWindowValue;
  YEAR: ITimeWindowValue;
}



// WEBPACK FOOTER //
// ./app/vendor/utility-js-time/src/main.ts